export default '5.0.0-experimental.25';
